<template>
  <v-list-item @click="open">
    <v-list-item-avatar>
      <v-icon small color="secondary">fal fa-plus</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="secondary--text">住所を追加する</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="text-xs-right">
      <v-btn text :disabled="true"></v-btn>
    </v-list-item-action>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">住所の追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-row dense>
                <v-col cols="11">
                  <v-text-field required
                    v-model="form.zip"
                    label="郵便番号"
                    mask="###-####"
                    :rules="rules.zip"
                    @keypress.enter="search"
                  />
                </v-col>
                <v-col cols="1">
                  <v-btn fab depressed x-small
                    color="secondary"
                    class="mt-3"
                    :loading="isSearching"
                    @click="search">
                    <v-icon small>fa-search</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-select required
                    v-model="form.pref"
                    label="都道府県"
                    :items="getPrefItems"
                    :rules="rules.pref"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field required
                    v-model="form.city"
                    label="市町村区"
                    :rules="rules.city"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field required
                    ref="number"
                    v-model="form.number"
                    label="番地・建物"
                    :rules="rules.number"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field required
                    v-model="form.kana"
                    label="ふりがな"
                    :rules="rules.kana"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text
            color="secondary"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="secondary"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
import moji from 'moji'
import axiosJsonpAdapter from 'axios-jsonp'
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        }
      },
      rules: {
        zip: [
          v => !!v || '必須項目です'
        ],
        pref: [
          v => !!v || '必須項目です'
        ],
        city: [
          v => !!v || '必須項目です'
        ],
        number: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ]
      },
      form: {
        valid: true,
        zip: '',
        pref: '',
        city: '',
        number: '',
        kana: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        zip: '',
        pref: '',
        city: '',
        number: '',
        kana: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'about/insert/address', {
            cid: this.$route.params.id,
            zip: this.form.zip,
            pref: this.form.pref,
            city: this.form.city,
            number: this.form.number,
            kana: this.form.kana
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: res.data.data
              })
            }
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'active', false)
          })
        })
      }
    },
    search: function () {
      if (this.form.zip.length === 7 && !this.config.status.searching) {
        this.$set(this.config.status, 'searching', true)
        this.axios.get(`${this.$url.zip}`, {
          adapter: axiosJsonpAdapter,
          params: {
            zipcode: this.form.zip
          }
        }).then(res => {
          console.log(res)
          if (res.status === 200) {
            const { results } = res.data
            const data = results[0]
            this.$set(this.form, 'pref', data.address1)
            this.$set(this.form, 'city', data.address2)
            this.$set(this.form, 'number', data.address3)
            this.$set(this.form, 'kana', moji(`${data.kana2}${data.kana3}`).convert('HK', 'ZK').convert('KK', 'HG').toString())
            this.$set(this.config.status, 'searching', false)
            this.$refs.number.focus()
            this.$store.dispatch('notifier/addSMessage', {
              title: '住所が見つかりました',
              message: `${data.address1}${data.address2}${data.address3}`
            })
          } else {
            this.$store.dispatch('notifier/addAlert', {
              title: '住所検索失敗',
              message: this.$error.zip.search.unmatch
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    convert: function (e) {
      console.log('converting...')
      console.log(e.target.value)
    }
  },
  watch: {
    'form.zip': function (v) {
      this.form.zip = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) { return String.fromCharCode(s.charCodeAt(0) - 65248) })
      if (v.length === 7) {
        this.search()
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    getPrefItems () {
      return Object.keys(this.$mango.prefs)
    }
  }
}
</script>
